export const AdSetTurnedOffIcon = ({ className, size = 27, ...props }) => (
    <svg
        {...props}
        width={size}
        height={size}
        viewBox="0 0 27 27"
        fill="none"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <mask id="path-3-inside-1_5868_51608" fill="white">
            <rect x="0.333984" y="6.33398" width="5.92593" height="5.92593" rx="0.888889" />
        </mask>
        <rect
            x="0.333984"
            y="6.33398"
            width="5.92593"
            height="5.92593"
            rx="0.888889"
            stroke="#E0295E"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            mask="url(#path-3-inside-1_5868_51608)"
        />
        <mask id="path-4-inside-2_5868_51608" fill="white">
            <rect x="7.74023" y="6.33398" width="5.92593" height="5.92593" rx="0.888889" />
        </mask>
        <rect
            x="7.74023"
            y="6.33398"
            width="5.92593"
            height="5.92593"
            rx="0.888889"
            stroke="#E0295E"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            mask="url(#path-4-inside-2_5868_51608)"
        />
        <mask id="path-5-inside-3_5868_51608" fill="white">
            <rect x="7.74023" y="13.7402" width="5.92593" height="5.92593" rx="0.888889" />
        </mask>
        <rect
            x="7.74023"
            y="13.7402"
            width="5.92593"
            height="5.92593"
            rx="0.888889"
            stroke="#E0295E"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            mask="url(#path-5-inside-3_5868_51608)"
        />
        <mask id="path-6-inside-4_5868_51608" fill="white">
            <rect x="0.333984" y="13.7402" width="5.92593" height="5.92593" rx="0.888889" />
        </mask>
        <rect
            x="0.333984"
            y="13.7402"
            width="5.92593"
            height="5.92593"
            rx="0.888889"
            stroke="#E0295E"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            mask="url(#path-6-inside-4_5868_51608)"
        />
        <path d="M16.3281 8V2" stroke="#E0295E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M20.3281 8V2" stroke="#E0295E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export default AdSetTurnedOffIcon
